<template>
    <address-list scope="all"></address-list>
</template>

<script>
import AddressList from '@/components/address/List.vue';

export default {
    name: 'AddressAllList',

    components: {
        AddressList,
    },
};
</script>
